<!--测品类发表观点按钮类组件 view:13 -->
<template>
    <div class="view14Wrapper  cardWidth shadowRadius cardPadding cardMinHeight">
        <div class="tipsGlobalText" v-if="tips!==''" v-html="tips">
            {{tips}}
        </div>
        <div class="v14Content">
        <div v-for="(it,ix) in list" :key="`vi-14-btn-${ix}`" class="v14BtnCls">
            <RButton color="themeBig"  @on-click="()=>onProgress(it.name,it.id,it.value)" >{{it.name}}</RButton>
        </div>
        </div>
    </div>
</template>
<script>
    import RButton from '../Use/r-button'
    export default {
        name: "View14",
        components: {RButton},
        props: {
            list: {
                type: Array,
                default: []
            },
            tips:{
                type: String,
                default: ''
            },
            other :{
                type: Object,
                default: {}
            },
        },
        data() {
            return {

            };

        },
        methods: {
            onProgress(name,id,value){

             this.$emit('on-process',name,id,value,this.other.sceneId,this.other.nodeId,this.other.sessionId)
            }

        }
    };
</script>
<style lang="less" scoped>
    .view14Wrapper {

        .v14Content{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .v14BtnCls{
            margin: .2rem 0;
        }
    }
</style>
